import parse from 'html-react-parser';
import Form from 'react-bootstrap/Form'
import {Col,Row,Stack} from 'react-bootstrap';
import {useEffect, useReducer, useState, useRef } from "react";
import { doPSOProviderRule,doPSOSpecialtiesRule,doPSOStateTerritoryRule, doOldProviderRule } from './SkipLogic';
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { trimNumber, trimString } from "Utils/utilityFunctions";
import { PageInfo } from 'Components/PageInformation/PageInformation';

function PSOFormFields({section, subSection, dispatch, question, setShowProvSection, formSectionVisibility, setFormSectionVisibility, setInputRefs, isLoading, isValuesLoading, pageType, reportYear, notes, userAnsState}) {

    //console.log(question);

    const ACTIONS = {
        CALL_API: 'call-api',
        SUCCESS: 'success',
        ERROR: 'error',
        SET_INITIAL_DATA: 'set-data',
        ADD_QUESTION: 'add-question',
        ADD_ANSWER: 'add-answer',

        UPDATE_QUESTION: 'update-question',
        UPDATE_ANSWER: 'update-answer',
        CLEAR_QUESTION_ANSWERS: 'clear-question-answers'
    }

    const getCheckboxNumberPlaceholderText = () => {
        var code =question.questionCode.toLowerCase();
        if(pageType!="VIEW"){
            if(code=="prov03"){
                return "Enter other type(s) of providers here";
            }
            else if(code=="prov07"){
                return "Enter other hospitals ownership categories here";
            }
            else {
                return null;
            }
        }
        else{
            return null;
        }
        
    }

    var displayLabel = function(label, isHidden, alignment, multi, f) {
        if(alignment==Row){
            if(multi==true){
                return (
                    <Col hidden={isHidden}
                        /*xs={getColLabelSizes('xs')} 
                        sm={getColLabelSizes('sm')} 
                        md={getColLabelSizes('md')} 
                        lg={getColLabelSizes('lg')} 
                        xl={getColLabelSizes('xl')} 
                        xxl={getColLabelSizes('xxl')} */
                    >
                        <legend>
                            {<span className="me-2">{label}</span>}
                            {/*fieldData.validation.required ? '' : <Badge bg="optional">Optional</Badge>*/}
                        </legend>
                    </Col>
                );
            }
            else{
                return (
                    <Form.Label visuallyHidden={isHidden} htmlFor={f} column
                      
                    >
                        {<span className="me-2">{label}</span>}
                        {/*fieldData.validation.required ? '' : <Badge bg="optional">Optional</Badge>*/}
                    </Form.Label>
                );
            }
        }
        else{
            if(multi==true){
                return (
                    <Row hidden={isHidden}
                       
                    >
                        <legend>
                            {label}
                            {/*fieldData.validation.required ? '' : <Badge bg="optional">Optional</Badge>*/}
                        </legend>
                    </Row>
                );
            }
            else{
                return (
                    <Form.Label htmlFor={f} visuallyHidden={isHidden}  
                        
                    >
                        {label}
                        {/*fieldData.validation.required ? '' : <Badge bg="optional">Optional</Badge>*/}
                    </Form.Label>
                );
            }
            
        }

    };

    

    const getQuestionIdByCode = (code, questions) => {
        //console.log(questions);
        var identifier = '';
        Object.keys(questions).map(key => {
            if(questions[key].questionCode === code)
            {
                identifier = questions[key].questionCode.toLowerCase();
            }
        })
    
        return identifier;
    }

   
    useEffect(()=>{
        //console.log("UPDATED");
        var showH = false;
        //console.log(question.questionCode);

        if(question.questionCode=="prov03"){
            var ans = section.questions.allProviderTypes[getQuestionIdByCode("prov03",section.questions["allProviderTypes"])].answers;
            
            var cb = getCheckedValueBoxes(ans);
            var vals = ['C001','C002','C183','C214','C215','C216'];
    
            if(Object.keys(cb).length > 0){
                for(var y = 0 ; y<vals.length ; y++){
                    if(cb.hasOwnProperty(vals[y])){
                        //if(cb[vals[y]]!=null && cb[vals[y]]!=""){
                            showH=true;
                        //}
                    }
                }
            }

           
            
            setFormSectionVisibility(
                {
                    ...formSectionVisibility,
                    HospitalsOnly: showH
                }
            );
        }
    },[section.questions.allProviderTypes])


    useEffect(()=>{
       
        //console.log("UPDATED-PARTIProv");
        if(question.questionCode=="pso30" || question.questionCode=="pso31" || question.questionCode=="pso30.1" || question.questionCode=="pso31.1"){
            var pso30 = section.questions.participatingProviders[getQuestionIdByCode("pso30",section.questions["participatingProviders"])];
            var pso30_1 = section.questions.participatingProviders[getQuestionIdByCode("pso30.1",section.questions["participatingProviders"])];
            var pso31 = section.questions.participatingProviders[getQuestionIdByCode("pso31",section.questions["participatingProviders"])];
            var pso31_1 = section.questions.participatingProviders[getQuestionIdByCode("pso31.1",section.questions["participatingProviders"])];
            //console.log(pso30);
            //console.log(pso31);
            if(pso30.value!=null && pso30.value!=""){
                //console.log("NOTNULL" + pso30.value);
            }

            //console.log(pso30_1);
            //console.log(pso31_1);
            //if(pso30.value!=-1 || pso31.value!=-1){
                if(isLoading==false && isValuesLoading==false){
                    doPSOProviderRule(pso30, pso30_1, pso31, pso31_1, setShowProvSection,dispatch, pageType);
                }
            //}
            //else{
            //    //console.log(pso30.value);
            //    //console.log(pso31.value);

            //}
            
        }

        if(reportYear.value<2020 && (question.questionCode=="pso25" || question.questionCode=="pso24")){
            var pso04 = section.questions.participatingProviders[getQuestionIdByCode("pso04",section.questions["participatingProviders"])];
            var pso25 = section.questions.participatingProviders[getQuestionIdByCode("pso25",section.questions["participatingProviders"])];
            var pso24 = section.questions.participatingProviders[getQuestionIdByCode("pso24",section.questions["participatingProviders"])];
           
            //console.log(pso31);
            

           
            doOldProviderRule(pso04, pso25, pso24, dispatch, pageType);
            
            
        }
        
    },[section.questions.participatingProviders])

    
    

    useEffect(()=>{
        //console.log("UPDATED-psochar");
        if(question.questionCode=="pso28"){

            //if((section.questions[subSection]["pso28"].answers).length > 0 && (section.questions[subSection]["pso28"].answers).find(a => a.answerCode === "C019").checked == true ){
            //    return true;
            //}
            var pso21 = section.questions.psoCharacteristics["pso21"];
            var pso28 = section.questions.psoCharacteristics["pso28"];
            
            /*//console.log(pso30);
            //console.log(pso31);

            //console.log(pso30_1);
            //console.log(pso31_1);*/
            if(isLoading==false)
            {
                doPSOSpecialtiesRule(pso21, pso28 ,dispatch, pageType);
            }
        }
        if(question.questionCode=="pso14"){

            //if((section.questions[subSection]["pso28"].answers).length > 0 && (section.questions[subSection]["pso28"].answers).find(a => a.answerCode === "C019").checked == true ){
            //    return true;
            //}
            var pso14 = section.questions.psoCharacteristics["pso14"];
            var pso26 = section.questions.psoCharacteristics["pso26"];
            //console.log(reportYear);
            /*//console.log(pso30);
            //console.log(pso31);

            //console.log(pso30_1);
            //console.log(pso31_1);*/
            doPSOStateTerritoryRule(pso14, pso26, dispatch, reportYear.value, pageType);
        }
        
    },[section.questions.psoCharacteristics])

    const updateAnswer = (e, dispatch, question, answerCode, subSection, type, a) => {
        //console.log("updateanswerdata" + answerCode + " " + e.target.value + " " + type + " " + question.typeCode + question.questionCode + " " + e.target.type);
        //console.log(e.target.value);
            if(question.typeCode=='CHECKBOX_NUMBER'){
                if(answerCode=="C012" || answerCode=="C199"){
                    if(e.target.type=="checkbox"){
                        dispatch({
                            type: ACTIONS.UPDATE_ANSWER,
                            questionId: question.id,
                            questionCode: question.questionCode,
                            subSection: subSection,
                            answerCode: answerCode,
                            checked: e.target.checked,
                            //readOnly: pageType=="VIEW" ? true : false,
                            //value: e.target.checked,
                            //visible: true,//!answerDisplayConditions(answerCode,e)
                            isInvalid: false,
                            errors:[],
                            pageType: pageType
                        }); 
                    }
                    else{
                        if(e.target.type=="number"){
                            dispatch({
                                type: ACTIONS.UPDATE_ANSWER,
                                questionId: question.id,
                                questionCode: question.questionCode,
                                subSection: subSection,
                                answerCode: answerCode,
                                //checked: true,
    
                                value: {
                                    number: e.target.value!=null && e.target.value > -1 ? trimNumber(e.target.value,6, 999999, 1) : "", //TODO
                                    text: a.value.text
                                },
    
                                //value: e.target.value != null ? Math.abs(e.target.value) : "",
                                //visible: true,
                                isInvalid: false,
                                errors:[],//!answerDisplayConditions(answerCode,e),
                                pageType: pageType
                            }); 
                        }
                        else if(e.target.type=="text"){
                            dispatch({
                                type: ACTIONS.UPDATE_ANSWER,
                                questionId: question.id,
                                questionCode: question.questionCode,
                                subSection: subSection,
                                answerCode: answerCode,
                                //checked: true,
    
                                value: {
                                    number: a.value.number,
                                    text: trimString(e.target.value,e.target.maxLength)
                                },
    
                                //value: e.target.value != null ? Math.abs(e.target.value) : "",
                                //visible: true,
                                isInvalid: false,
                                errors:[],
                                pageType: pageType//!answerDisplayConditions(answerCode,e)
                            }); 
                        }
                        else{
                            dispatch({
                                type: ACTIONS.UPDATE_ANSWER,
                                questionId: question.id,
                                questionCode: question.questionCode,
                                subSection: subSection,
                                answerCode: answerCode,
                                value: e.target.value,
                                //checked: e.target.checked,
                                //visible: true,
                                isInvalid: false,
                                errors:[],
                                pageType: pageType//!answerDisplayConditions(answerCode,e)
                            }); 
                        }
                    }
                }
                else{
                    if(e.target.type=="checkbox"){
                        dispatch({
                            type: ACTIONS.UPDATE_ANSWER,
                            questionId: question.id,
                            questionCode: question.questionCode,
                            subSection: subSection,
                            answerCode: answerCode,
                            checked: e.target.checked,
                            //value: e.target.checked,
                            
                            //visible: false,//!answerDisplayConditions(answerCode,e)
                            isInvalid: false,
                            errors:[],
                            pageType: pageType
                        }); 
                    }
                    else{
                        if(e.target.type=="number"){
                            dispatch({
                                type: ACTIONS.UPDATE_ANSWER,
                                questionId: question.id,
                                questionCode: question.questionCode,
                                subSection: subSection,
                                answerCode: answerCode,
                                checked: e.target.value!="" && e.target.value!=null && e.target.value > -1 ? true : false,

                                value: e.target.value!="" && e.target.value!=null && e.target.value > -1 ? trimNumber(e.target.value,6, 999999,1) : "" , //TODO

                                //value: e.target.value != null ? Math.abs(e.target.value) : "",
                                //visible: true,
                                isInvalid: false,
                                errors:[],
                                pageType: pageType//!answerDisplayConditions(answerCode,e)
                            }); 
                        }
                        else if(e.target.type=="text"){
                            dispatch({
                                type: ACTIONS.UPDATE_ANSWER,
                                questionId: question.id,
                                questionCode: question.questionCode,
                                subSection: subSection,
                                answerCode: answerCode,
                                //checked: true,

                                value:trimString(e.target.value,e.target.maxLength),

                                //value: e.target.value != null ? Math.abs(e.target.value) : "",
                                //visible: true,
                                isInvalid: false,
                                errors:[],
                                pageType: pageType//!answerDisplayConditions(answerCode,e)
                            }); 
                        }
                        else{
                            dispatch({
                                type: ACTIONS.UPDATE_ANSWER,
                                questionId: question.id,
                                questionCode: question.questionCode,
                                subSection: subSection,
                                answerCode: answerCode,
                                value: e.target.value,
                                //checked: e.target.checked,
                                //visible: true,
                                isInvalid: false,
                                errors:[],
                                pageType: pageType//!answerDisplayConditions(answerCode,e)
                            }); 
                        }
                    }
                
                    
                }
                
            }
            else if(question.typeCode=='CHECKBOX' && (answerCode=="C012" || answerCode=="C199")){
                if(e.target.type!="checkbox"){
                    dispatch({
                        type: ACTIONS.UPDATE_ANSWER,
                        questionId: question.id,
                        questionCode: question.questionCode,
                        subSection: subSection,
                        answerCode: answerCode,
                        //checked: e.target.checked,
                        value: e.target.value,
                        //visible: true,
                        isInvalid: false,
                        errors:[],
                        pageType: pageType// !answerDisplayConditions(answerCode,e)
                    }); 
                }
                else{
                    dispatch({
                        type: ACTIONS.UPDATE_ANSWER,
                        questionId: question.id,
                        questionCode: question.questionCode,
                        subSection: subSection,
                        answerCode: answerCode,
                        checked: e.target.checked,
                        //value: e.target.value,
                        //visible: true,
                        isInvalid: false,
                        errors:[],
                        pageType: pageType//!answerDisplayConditions(answerCode,e)
                    }); 
                }
                
                
            }
            else{
                //console.log("ELSE" + question.questionCode);
                if(e.target.type=="checkbox" || e.target.type=="radio"){
                    dispatch({
                        type: ACTIONS.UPDATE_ANSWER,
                        questionId: question.id,
                        questionCode: question.questionCode,
                        subSection: subSection,
                        answerCode: answerCode,
                        checked: e.target.checked,
                        //value: e.target.checked,
                        //visible: true,
                        isInvalid: false,
                        errors:[],
                        pageType: pageType//!answerDisplayConditions(answerCode,e)
                    }); 
                }
                else{
                    dispatch({
                        type: ACTIONS.UPDATE_ANSWER,
                        questionId: question.id,
                        questionCode: question.questionCode,
                        subSection: subSection,
                        answerCode: answerCode,
                        value: e.target.value,
                        //checked: e.target.checked,
                        //visible: true,
                        isInvalid: false,
                        errors:[],
                        pageType: pageType//!answerDisplayConditions(answerCode,e)
                    }); 
                }
                
            }
       
        
            dispatch({
                type: ACTIONS.UPDATE_QUESTION,
                questionId: question.id,
                questionCode: question.questionCode,
                subSection: subSection,
                isInvalid: false,
                errors:[],
                pageType: pageType
            }); 
       
        
    }

    const updateQuestion = (e, dispatch, question, subSection) => {
        //console.log("updatequestiondata" + JSON.stringify(question) + " " + e.target.value);

        if(question.typeCode=='NUMBER' && (question.questionCode=="pso30" || question.questionCode=="pso31")){
            if(e.target.type!="checkbox"){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: question.id,
                    questionCode: question.questionCode,
                    subSection: subSection,
                    value: e.target.value != null && e.target.value > -1 ? trimNumber(e.target.value,question.maxLength, question.maxValue) : question.value,
                    checked: false,
                    isInvalid: false,
                    errors:[],
                    pageType: pageType
                }); 
            }
            else{
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: question.id,
                    questionCode: question.questionCode,
                    subSection: subSection,
                    value: e.target.checked == true ? -1 : question.value,
                    checked: e.target.checked,
                    isInvalid: false,
                    errors:[],
                    pageType: pageType
                }); 
            }
            
            
        }
        else if(e.target.type=="number"){
            dispatch({
                type: ACTIONS.UPDATE_QUESTION,
                questionId: question.id,
                questionCode: question.questionCode,
                subSection: subSection,
                value: e.target.value != null && e.target.value > -1 ? trimNumber(e.target.value,question.maxLength, question.maxValue) : question.value,
                checked: false,
                isInvalid: false,
                errors:[],
                pageType: pageType
            }); 
        }
        else if(e.target.type=="date"){
           
            var val = e.target.value;
            //console.log(val);
            if(val != null)  {
                var split = val.split("-");
                var value = "";

                if(split[0].length > 4) {
                    value=(val.substring(val.length-7,val.length)).padStart(10,"0");
                    
                }
                else {
                    value=val;
                }
            } 
            else {
                value='';
            }
            dispatch({
                type: ACTIONS.UPDATE_QUESTION,
                questionId: question.id,
                questionCode: question.questionCode,
                subSection: subSection,
                value: value,
                checked: false,
                isInvalid: false,
                errors:[],
                pageType: pageType
            }); 
        }
        else if(question.typeCode=='NUMBER_NP'){
            //console.log(question);
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: question.id,
                    questionCode: question.questionCode,
                    subSection: subSection,
                    value: e.target.value != null ? trimString(e.target.value,question.maxLength, question.maxValue) : question.value,
                    checked: false,
                    isInvalid: false,
                    errors:[],
                    pageType: pageType
                }); 
        }
        else{
             dispatch({
                type: ACTIONS.UPDATE_QUESTION,
                questionId: question.id,
                questionCode: question.questionCode,
                subSection: subSection,
                value: e.target.value,
                checked: e.target.checked !=null ? e.target.checked : question.checked,
                isInvalid: false,
                errors:[],
                disabled: e.target.disabled,
                pageType: pageType
                //!questionDisplayConditions()
            }); 
        }

       
    }

    


const checkboxField = (index, q) => {
    if(pageType=="VIEW"){
        return (
            <p>
                { q.answers[index].description != null && q.answers[index].checked == true
                ?   parse(q.answers[index].description) 
                :   null}
            </p>
        )
    }
    else{
        return (
            <Form.Check
                key={"answer" + q.answers[index].id + "_" + q.answers[index].answerCode}
                type="checkbox"
                id={"answer" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                //title={v.title}
                label={ 
                    q.answers[index].description != null 
                    ?   parse(q.answers[index].description) 
                    :   null
                }
                name={"check_answer_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                value={q.answers[index].value}
                onChange={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection)}
                className={"mt-2 mb-2 "}
                checked={q.answers[index].checked}
                isInvalid={q.answers[index].isInvalid}
                isValid={q.answers[index].isValid}
                disabled={pageType=="VIEW" ? true : false}
                
                //disabled={disabled(v.disabled, fieldData.disabled)}//v.disabled ? true : false}
                //ref={fieldData.InputRef}
                //className={index > 0  ? "mt-2":""}
            />
        )
    }
    
}

function noneConditions(){
    if(question.questionCode == 'pso32'){
        if((section.questions[subSection][question.questionCode.toLowerCase()/* + "_" + question.id*/].answers).length > 0 && (section.questions[subSection][question.questionCode.toLowerCase()/* + "_" + question.id*/].answers).find(a => a.answerCode === "C192").checked == true) {
            //section.questions[subSection]["pso28"].answers).length > 0 && (section.questions[subSection]["pso28"].answers).find(a => a.answerCode === "C019").checked == true 
            /*var arr = section.questions[subSection]["pso32"].answers;
            for(var x = 0 ; x<arr.length ; x++){
                if(arr[x].answerCode != "C192"){
                    dispatch({
                        type: ACTIONS.UPDATE_ANSWER,
                        questionCode: "pso32",
                        subSection: subSection,
                        answerCode: arr[x].answerCode,
                        //value: e.target.value,
                        checked: false
                    }); 
                }
                        
            }*/
           return false;
        }
        else if ((section.questions[subSection][question.questionCode.toLowerCase() + "_" + question.id].answers).length > 0 && (section.questions[subSection][question.questionCode.toLowerCase() + "_" + question.id].answers).find(a => a.answerCode === "C192").checked != true){
            return true;
        }   
    }
    
}

var displayErrors = (data) => {
        //console.log(data);
    return (
        <div>
            {data.errors.length > 0 ? data.errors.map((errorText,index) => 
                <Stack key={data.questionCode + "Errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                    <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                    <div>{errorText}</div>
                </Stack>
                
            ) : JSON.stringify(data)}
        </div>
    );
}

function getCheckedBoxes(answers) {
    var boxes = [];
    /*
        checkedBoxes == null || (checkedBoxes.indexOf('C001') < 0  && checkedBoxes.indexOf('C002') < 0  && checkedBoxes.indexOf('C183') < 0 
			&& checkedBoxes.indexOf('C214') < 0  && checkedBoxes.indexOf('C215') < 0  && checkedBoxes.indexOf('C216') < 0 )
    */
    answers.map(function(value,index) {
        ////console.log(index);
        ////console.log(value);
        if(value.checked==true){
            boxes.push(value.answerCode)
        }
        else{
            boxes.push("");
        }
    })

    //console.log(boxes);
    return boxes.length > 0 ? boxes : null;
}

function getCheckedValueBoxes(answers) {
    var boxes = {};
    /*
        checkedBoxes == null || (checkedBoxes.indexOf('C001') < 0  && checkedBoxes.indexOf('C002') < 0  && checkedBoxes.indexOf('C183') < 0 
			&& checkedBoxes.indexOf('C214') < 0  && checkedBoxes.indexOf('C215') < 0  && checkedBoxes.indexOf('C216') < 0 )
    */
    answers.map(function(value,index) {
        ////console.log(index);
        //console.log(value);
        if(value.checked==true){
            //console.log(value['value']);
            //console.log(value['answerCode']);
            boxes[value.answerCode]=value['value'];
        }
        return;
    })

    //console.log(boxes);
    return Object.keys(boxes).length > 0 ? boxes : {};
}

const isAnyAnswered = (answers) => {
    var answered = {};
    //console.log(answers);
    answers.map(function(value,index) {
        ////console.log(index);
        //console.log(value);
        if(value!=null && value!=""){
            
            //console.log(value['value']);
            //console.log(value['answerCode']);
            answered[value.answerCode]=value['value'];
        }
        return;
    })

    //console.log(answered);
    return Object.keys(answered).length > 0 ? true : false;
}

const isOtherFullyEmpty = (data)=> {
    if(data.value.number!=null && data.value.number!=""){
        return false;
    }
    if(data.value.text!=null && data.value.text!=""){
        return false;
    }
    if(data.checked==true){
        return false;
    }
    return true;

}

const answerLoop = () => {
    //console.log(question);

    var geoType = null;
    var sectionLabel = null;
    
    return section.questions[subSection][question.questionCode.toLowerCase()].answers.map(function(value,index) {
        ////console.log(index);
        ////console.log(value);

        var q = section.questions[subSection][question.questionCode.toLowerCase()];
        ////console.log(q);

        if(reportYear.value>2019 && q.questionCode==="pso26"){
            //if(reportYear.value==2020){

            //        geoType="state";
           //         sectionLabel = <legend><strong>States:</strong></legend>;
            //}

            //else{
                if((q.answers[index].answerCode==="C110" && pageType=="VIEW" && userAnsState==true) || (q.answers[index].answerCode==="C110" && pageType!="VIEW" )){
                    geoType="state";
                    sectionLabel = <legend><strong>States:</strong></legend>;
                }
                else if(q.answers[index].answerCode==="C112"){
                    geoType="territory";
                    sectionLabel = <legend><strong>Federal District and U.S. Territories:</strong></legend>;
                }
                else {
                    sectionLabel = null;
                }
            //}
            
        }
        else{
            sectionLabel = null;
        }
            

            if(answerDisplayConditions(q.answers[index].answerCode, geoType) != true){
                switch (q.typeCode) {
            
                    case 'CHECKBOX':
                        
                        return (
                            <div className="mb-1 mt-1">
                                {sectionLabel}
                                {
                                    checkboxField(index,q)
                                }
                                {
                                    (q.answers[index].answerCode=="C012" || q.answers[index].answerCode=="C199") && (pageType!="VIEW")
                                    ?
                                        <>
                                            <Form.Label visuallyHidden={true} htmlFor={"answertext" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()}>
                                            { 
                                                q.answers[index].description
                                            }
                                            </Form.Label>
                                            <Form.Control
                                                className="mt-2 mb-2"
                                                type={'text'}
                                                id={"answertext" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()}
                                                name={q.answers[index].answerCode}
                                                value={trimString(q.answers[index].value,q.answers[index].maxLength)}
                                                onChange={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection,'CHECKBOX_NUMBER')}
                                                disabled={pageType=="VIEW" ? true : false}
                                                maxLength={q.answers[index].maxLength !=null ? q.answers[index].maxLength : null}
                                                title={q.answers[index].maxLength != null ? "Maximum answer value allowed for this question is " + q.answers[index].maxLength + " characters" : null}
                                            />
                                        </>
                                    :   pageType=="VIEW" && ((trimString(q.answers[index].value,q.answers[index].maxLength)!=null && trimString(q.answers[index].value,q.answers[index].maxLength)!="") || q.answers[index].checked==true) && (q.answers[index].answerCode=="C012" || q.answers[index].answerCode=="C199")
                                            ?   <>
                                                    <Form.Label visuallyHidden={true} htmlFor={"answertext" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()}>
                                                    { 
                                                        q.answers[index].description
                                                    }
                                                    </Form.Label>
                                                    <Form.Control
                                                        className="mt-2 mb-2"
                                                        type={'text'}
                                                        id={"answertext" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()}
                                                        name={q.answers[index].answerCode}
                                                        value={trimString(q.answers[index].value,q.answers[index].maxLength)}
                                                        onChange={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection,'CHECKBOX_NUMBER')}
                                                        disabled={pageType=="VIEW" ? true : false}
                                                        maxLength={q.answers[index].maxLength !=null ? q.answers[index].maxLength : null}
                                                        title={q.answers[index].maxLength != null ? "Maximum answer value allowed for this question is " + q.answers[index].maxLength + " characters" : null}
                                                    />
                                                </>
                                            : null
                                }
                            </div>
                        );
                    case 'CHECKBOX_NUMBER':
                        if(pageType=="VIEW" && isOtherFullyEmpty(q.answers[index])==true){
                            return null;
                        }
                        else{
                            return (
                                <div className="check_num_field ps-2 pe-2 pt-3 pb-3">
                                    {sectionLabel}
                                    {pageType!="VIEW" ?
                                            <Form.Check
                                                key={"answer" + q.answers[index].id + "_" + q.answers[index].answerCode}
                                                type="checkbox"
                                                id={"answer" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()}
                                                label={ 
                                                    q.answers[index].description != null 
                                                    ?   parse(q.answers[index].description) 
                                                    :   null
                                                }
                                                name={"check_answer_" + question.questionCode.toLowerCase()} 
                                                onChange={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection, 'CHECKBOX_NUMBER')}
                                                checked={q.answers[index].checked}
                                                isInvalid={q.answers[index].isInvalid}
                                                isValid={q.answers[index].isValid}
                                                disabled={pageType=="VIEW" ? true : false}
                                            
                                            />
                                        : 
                                        null
                                    }
                                    {

                                        
                                            (q.answers[index].answerCode=="C012" || q.answers[index].answerCode=="C199") ?
                                                <>
                                                    <Form.Label className="form-check-label" visuallyHidden={pageType!="VIEW" ? true : false} htmlFor={"answernum" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()}>
                                                    { 
                                                        q.answers[index].description
                                                    }
                                                    </Form.Label>
                                                    <div >
                                                        <Form.Control
                                                            className="p-2 mt-2"
                                                            key={"answernum" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                                            type="number"
                                                            id={"answernum" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                                            value={trimNumber(q.answers[index].value.number, q.answers[index].maxLength, q.answers[index].maxValue) <1 ? "" : trimNumber(q.answers[index].value.number, q.answers[index].maxLength, q.answers[index].maxValue)}
                                                            onChange={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection,'CHECKBOX_NUMBER', q.answers[index])}
                                                            onBlur={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection,'CHECKBOX_NUMBER', q.answers[index])}
                                                            isInvalid={q.answers[index].isInvalid}
                                                            isValid={q.answers[index].isValid}
                                                            title={"Enter number of providers between 1 and 999999"} 
                                                            disabled={pageType=="VIEW" ? true : false}
                                                        ></Form.Control>

                                                        <Form.Label visuallyHidden={true} htmlFor={"answertext" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()}>
                                                        { 
                                                            q.answers[index].description
                                                        }
                                                        </Form.Label>
                                                        <Form.Control
                                                            type={'text'}
                                                            id={"answertext" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()}
                                                            name={q.answers[index].answerCode}
                                                            value={trimString(q.answers[index].value.text, q.answers[index].maxLength)}
                                                            className="mt-2 mb-2"
                                                            placeholder={getCheckboxNumberPlaceholderText()}
                                                            onChange={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection,'CHECKBOX_NUMBER', q.answers[index])}
                                                            isInvalid={q.answers[index].isInvalid}
                                                            isValid={q.answers[index].isValid}
                                                            maxLength={q.answers[index].maxLength !=null ? q.answers[index].maxLength : null}
                                                            title={q.answers[index].maxLength != null ? "Maximum answer value allowed for this question is " + q.answers[index].maxLength + " characters" : null}
                                                            disabled={pageType=="VIEW" ? true : false}
                                                        />
                                                        
                                                    </div>
                                                </>
                                            :   <>
                                                    <Form.Label className="form-check-label" visuallyHidden={pageType!="VIEW" ? true : false} htmlFor={"answernum" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()}>
                                                    { 
                                                        q.answers[index].description
                                                    }
                                                    </Form.Label>
                                                    <Form.Control
                                                        className="p-2 mt-2"
                                                        key={"answernum" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                                        type="number"
                                                        id={"answernum" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                                        value={trimNumber(q.answers[index].value, q.answers[index].maxLength, q.answers[index].maxValue) <1 ? "" : trimNumber(q.answers[index].value, q.answers[index].maxLength, q.answers[index].maxValue)}
                                                        onChange={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection,'CHECKBOX_NUMBER')}
                                                        onBlur={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection,'CHECKBOX_NUMBER')}
                                                        isInvalid={q.answers[index].isInvalid}
                                                        isValid={q.answers[index].isValid}
                                                        title={q.answers[index].maxValue!=null ? "If none, enter '0'. Maximum answer value for this question is " + q.answers[index].maxValue : "Enter number of providers between 1 and 999999"} 
                                                        disabled={pageType=="VIEW" ? true : false}
                                                    ></Form.Control>
                                                </>
                                    
                                    }
                                    
                                    
                                    
                                </div>
                            );
                        }
                            
                    case 'RADIO':
                        return (
                            <div className="mb-1 mt-1">
                                {sectionLabel}
                                
                                {pageType!="VIEW"
                                    ? <Form.Check
                                            key={"answer" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                            type="radio"
                                            id={"answer" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                            //title={v.title}
                                            label={ 
                                                q.answers[index].description != null 
                                                ?   parse(q.answers[index].description) 
                                                :   null
                                            }
                                            name={"radio_answer"  + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                            value={q.answers[index].value}
                                            onChange={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection)}
                                            checked={q.answers[index].checked}
                                            isInvalid={q.answers[index].isInvalid}
                                            isValid={q.answers[index].isValid}
                                            className="mt-2"
                                            disabled={q.answers[index].disabled || pageType=="VIEW" ? true : false}
                                            //ref={fieldData.InputRef}
                                            //className={index > 0  ? "mt-2":""}
                                        />
                                    : 
                                            <p>
                                                { q.answers[index].description != null && q.answers[index].checked == true
                                                ?   parse(q.answers[index].description) 
                                                :   null}
                                            </p>
                                        
                                }
                                
                                {
                                    q.answers[index].answerCode=="C012" || q.answers[index].answerCode=="C199" ?
                                    <>
                                        <Form.Label visuallyHidden={true} htmlFor={"answertext" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()}>
                                            { 
                                                q.answers[index].description
                                            }
                                            </Form.Label>
                                        <Form.Control
                                            type={'text'}
                                            id={"answertext" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()}
                                            name={q.answers[index].answerCode}
                                            value={trimString(q.answers[index].value, q.answers[index].maxLength)}
                                            className="mt-2 mb-2"
                                            //placeholder={fieldData.display.placeholder}
                                            //title={fieldData.display.title}
                                            onChange={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection)}
                                            //isInvalid={fieldData.validation.isInvalid ? "invalid":""}
                                            //isValid={fieldData.validation.isValid ? "valid":""}
                                            //readOnly={getVarValue(fieldData.readOnly) ? 'readOnly' : ''}
                                            disabled={pageType=="VIEW" ? true : false}
                                            maxLength={q.answers[index].maxLength !=null ? q.answers[index].maxLength : null}
                                            title={q.answers[index].maxLength != null ? "Maximum answer value allowed for this question is " + q.answers[index].maxLength + " characters" : null}
                                            
                                            //maxLength={fieldData.display.maxLength}
                                            //inputMode={props.inputmode} 
                                            //pattern={props.pattern} 
                                            //ref={fieldData.InputRef}
                                        />
                                    </>
                                    : pageType=="VIEW" && ((trimString(q.answers[index].value,q.answers[index].maxLength)!=null && trimString(q.answers[index].value,q.answers[index].maxLength)!="") || q.answers[index].checked==true) && (q.answers[index].answerCode=="C012" || q.answers[index].answerCode=="C199")
                                        ? <>
                                        <Form.Label visuallyHidden={true} htmlFor={"answertext" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()}>
                                            { 
                                                q.answers[index].description
                                            }
                                            </Form.Label>
                                        <Form.Control
                                            type={'text'}
                                            id={"answertext" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()}
                                            name={q.answers[index].answerCode}
                                            value={trimString(q.answers[index].value, q.answers[index].maxLength)}
                                            className="mt-2 mb-2"
                                            //placeholder={fieldData.display.placeholder}
                                            //title={fieldData.display.title}
                                            onChange={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection)}
                                            //isInvalid={fieldData.validation.isInvalid ? "invalid":""}
                                            //isValid={fieldData.validation.isValid ? "valid":""}
                                            //readOnly={getVarValue(fieldData.readOnly) ? 'readOnly' : ''}
                                            disabled={pageType=="VIEW" ? true : false}
                                            maxLength={q.answers[index].maxLength !=null ? q.answers[index].maxLength : null}
                                            title={q.answers[index].maxLength != null ? "Maximum answer value allowed for this question is " + q.answers[index].maxLength + " characters" : null}
                                            
                                            //maxLength={fieldData.display.maxLength}
                                            //inputMode={props.inputmode} 
                                            //pattern={props.pattern} 
                                            //ref={fieldData.InputRef}
                                        />
                                    </>
                                        : null
                                }
                                
                            </div>
                        );
                    case 'NUMBER':
                        
                        return (
                            <div className="mb-1 mt-1">
                                {sectionLabel}
                                {pageType!="VIEW" ?
                                    <Form.Control
                                        key={"answer" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                        type="number"
                                        id={"answer" + q.answers[index].id + "_" + q.answers[index].answerCode  + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                        value={trimNumber(q.answers[index].value, q.answers[index].maxLength, q.answers[index].maxValue)}
                                        onChange={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection)}
                                        
                                        disabled={pageType=="VIEW" ? true : false}
                                        isInvalid={q.answers[index].isInvalid}
                                        isValid={q.answers[index].isValid}
                                        title={q.answers[index].maxValue!=null ? "If none, enter '0'. Maximum answer value for this question is " + q.answers[index].maxValue : null} 
                                        
                                    />
                                    : 
                                   
                                        
                                            q.answers[index].value != null && q.answers[index].value != ""
                                            ?   <Form.Control
                                                    key={"answer" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                                    type="number"
                                                    id={"answer" + q.answers[index].id + "_" + q.answers[index].answerCode  + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                                    value={trimNumber(q.answers[index].value, q.answers[index].maxLength, q.answers[index].maxValue)}
                                                    onChange={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection)}
                                                    
                                                    disabled={pageType=="VIEW" ? true : false}
                                                    isInvalid={q.answers[index].isInvalid}
                                                    isValid={q.answers[index].isValid}
                                                    title={q.answers[index].maxValue!=null ? "If none, enter '0'. Maximum answer value for this question is " + q.answers[index].maxValue : null} 
                                                    
                                                />
                                            :   null
                                    
                                   
                                }
                                
                            </div>
                        );
                    case 'INDT_NUMBER':
                        
                        return (
                            <div className="mb-1 mt-1">
                                {sectionLabel}
                                <Form.Control
                                    key={"answer" + q.answers[index].id + "_" + q.answers[index].answerCode + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                    type="number"
                                    id={"answer" + q.answers[index].id + "_" + q.answers[index].answerCode  + "_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                    //title={v.title}
                                    /*label={ 
                                        q.answers[index].description != null 
                                        ?   parse(q.answers[index].description) 
                                        :   <p>Test</p>
                                    }*/
                                    //name={v.name}
                                    value={trimNumber(q.answers[index].value, q.answers[index].maxLength, q.answers[index].maxValue)}
                                    onChange={(e) => updateAnswer(e, dispatch, question, q.answers[index].answerCode, subSection)}
                                    //checked={false}
                                    isInvalid={q.answers[index].isInvalid}
                                    isValid={q.answers[index].isValid}
                                    disabled={pageType=="VIEW" ? true : false}
                                    title={q.answers[index].maxValue!=null ? "If none, enter '0'. Maximum answer value for this question is " + q.answers[index].maxValue : null} 
                                    //max={q.answers[index].maxLength!=null ? q.answers[index].maxLength : null}
                                    //disabled={disabled(v.disabled, fieldData.disabled)}//v.disabled ? true : false}
                                    //ref={fieldData.InputRef}
                                    //className={index > 0  ? "mt-2":""}
                                />
                                
                            </div>
                        );
                }
            }
            else{
                return null;
            }
        
        
        
    })

    /*return (
        
            q.answers[index].answerCode==="C110"
            ?   <>
                    <strong>States:</strong>
                    {maps}
                </>
            : q.answers[index].answerCode==="C112"
                ?   <>
                        <strong>Federal District and U.S. Territories:</strong>
                        {maps}
                    </>
                : null

        
    )*/
    
}


const questionLabel = (q) => {
    if(q.questionDisplayNo == null &&  q.description!=null){
        return parse(q.description);
    }
}



const questionField = () => {


   
    
        var q = section.questions[subSection][question.questionCode.toLowerCase()/* + "_" + question.id*/]; 
        
        /*if(q.questionDisplayNo != null &&  q.description!=null){
            <Stack className="align-items-start" direction="horizontal" gap={0}>
                <div className="ps-3 col-1">{null}</div>
                <div className="">{displayLabel(parse(q.description), false, Col,false)}</div>
            </Stack>
        }*/
        
        /*section.questions[subSection][question.questionCode.toLowerCase()].description != null
                ?   <Stack className="align-items-start" direction="horizontal" gap={0}>
                        <div className="ps-3 col-1">{null}</div>
                        <div className="">{displayLabel(parse(section.questions[subSection][question.questionCode.toLowerCase() ].description), false, Col,false)}</div>
                    </Stack>
                :   null*/


        ////console.log(JSON.stringify(q));
        switch (q.typeCode) {
            
            case 'CHECKBOX':
                
                
                    return (
                        <div className="mb-1 mt-1" >
                            <Form.Check
                                key={"q_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                type="checkbox"
                                id={"q_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                //title={v.title}
                                label={ 
                                    q.description != null 
                                    ?   parse(q.description) 
                                    :   null
                                }
                                name={q.questionCode}
                                value={q.value}
                                onChange={(e) => updateQuestion(e, dispatch, question, subSection)}

                                checked={q.checked}
                                isInvalid={q.isInvalid}
                                isValid={q.isValid}
                                disabled={pageType=="VIEW" ? true : false}  
                            />
                        </div>
                   
                    
                    );
                
                
            case 'CHECKBOX_NUMBER':
                //if(pageType=="VIEW" ){
                    //if(){

                    //}
                    //else{
                    //    return null;
                    //}
                //}
                //else{
                    return (

                        <div className="mb-1 mt-1">
                            <Form.Check
                                key={"qchk_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                type="checkbox"
                                id={"qchk_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                //title={v.title}
                                label={ 
                                    q.description != null 
                                    ?   parse(q.description) 
                                    :   null
                                }
                                name={q.questionCode}
                                value={q.value}
                                onChange={(e) => updateQuestion(e, dispatch, question, subSection)}
                                disabled={pageType=="VIEW" ? true : false}
                                checked={q.checked}
                                isInvalid={q.isInvalid}
                                isValid={q.isValid}
                                //readOnly={pageType=="VIEW" ? true : false}
                                //ref={fieldData.InputRef}
                                //className={index > 0  ? "mt-2":""}
                            />
                            {   question.questionCode=="pso29" 
                                ?   null
                                :   <Form.Control
                                        key={"q_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                        type="number"
                                        id={"q_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                        //title={v.title}
                                        /*label={ 
                                            q.description != null 
                                            ?   parse(q.description) 
                                            :   null
                                        }*/
                                        name={"number"+q.questionCode}
                                        value={trimNumber(q.value, q.maxLength, q.maxValue)}
                                        onChange={(e) => updateQuestion(e, dispatch, question, subSection)}
                                        //checked={false}
                                        isInvalid={q.isInvalid}
                                        isValid={q.isValid}
                                        disabled={pageType=="VIEW" ? true : false}
                                        title={q.maxValue!=null ? "If none, enter '0'. Maximum answer value for this question is " + q.maxValue : "Enter number of providers between 1 and 999999" } 
                                        //max={q.maxLength!=null ? q.maxLength : 6}
                                        //hidden={question.questionCode=="pso29" ? true : false}
                                        //disabled={disabled(v.disabled, fieldData.disabled)}//v.disabled ? true : false}
                                        //ref={fieldData.InputRef}
                                        //className={index > 0  ? "mt-2":""}
                                    />
                            }   
                            
                            
                        </div>
                    );
                //}
                
            case 'RADIO':
                return (
                    <div className="mb-1 mt-1">
                     

                            <Form.Check
                                key={"q_" + question.questionCode.toLowerCase() /* + "_" + question.id*/}
                                type="radio"
                                id={"q_" + question.questionCode.toLowerCase() /* + "_" + question.id*/}
                                //title={v.title}
                                label={ 
                                    q.description != null 
                                    ?   parse(q.description) 
                                    :   null
                                }
                                name={q.questionCode}
                                value={q.value}
                                onChange={(e) => updateQuestion(e, dispatch, question, subSection)}
                                checked={q.checked}
                                isInvalid={q.isInvalid}
                                disabled={pageType=="VIEW" ? true : false}
                                isValid={q.isValid}
                                //disabled={disabled(v.disabled, fieldData.disabled)}//v.disabled ? true : false}
                                //ref={fieldData.InputRef}
                                //className={index > 0  ? "mt-2":""}
                            />

                    </div>
                );
            case 'NUMBER_NP':
                if(pageType=="VIEW" && q.value!=null && q.value!=""){
                    if(q.value=="-1" || q.value==-1){
                        return <p>NA</p>;
                    }
                    else{
                        return (
                            <div className="mb-1 mt-1">
                            
                                <Form.Control
                                
                                    type="text"
                                    //keyboardType="numeric"
                                    id={"q_" + question.questionCode.toLowerCase() /* + "_" + question.id*/}
                                    //title={v.title}
                                    /*label={ 
                                        q.description != null 
                                        ?   parse(q.description) 
                                        :   null
                                    }*/
                                    name={q.questionCode}
                                    value={q.value/*trimString(, q.maxLength, q.maxValue)*/}
                                    onChange={(e) => updateQuestion(e, dispatch, question, subSection)}
                                    //checked={false}
                                    isInvalid={q.isInvalid}
                                    isValid={q.isValid}
                                    //hidden={question.questionCode.toLowerCase()=="pso29" ? true : false}
                                    //min="1"
                                    disabled={q.checked==true || pageType=="VIEW"? true : q.disabled}
                                    title={q.maxValue!=null ? "If none, enter '0'. Maximum answer value for this question is " + q.maxValue : null} 
                                    //max={q.maxLength!=null ? q.maxLength : null}
                                    //ref={fieldData.InputRef}
                                    //className={index > 0  ? "mt-2":""}
                                >
                            
                            </Form.Control>
                        </div>);
                    }
                    
                }   
                else{
                    return (
                        <div className="mb-1 mt-1">
                            
                            <Form.Control
                                    
                                        type="text"
                                        //keyboardType="numeric"
                                        id={"q_" + question.questionCode.toLowerCase() /* + "_" + question.id*/}
                                        //title={v.title}
                                        /*label={ 
                                            q.description != null 
                                            ?   parse(q.description) 
                                            :   null
                                        }*/
                                        name={q.questionCode}
                                        value={q.value/*trimString(, q.maxLength, q.maxValue)*/}
                                        onChange={(e) => updateQuestion(e, dispatch, question, subSection)}
                                        //checked={false}
                                        isInvalid={q.isInvalid}
                                        isValid={q.isValid}
                                        //hidden={question.questionCode.toLowerCase()=="pso29" ? true : false}
                                        //min="1"
                                        disabled={q.checked==true || pageType=="VIEW"? true : q.disabled}
                                        title={q.maxValue!=null ? "If none, enter '0'. Maximum answer value for this question is " + q.maxValue : null} 
                                        //max={q.maxLength!=null ? q.maxLength : null}
                                        //ref={fieldData.InputRef}
                                        //className={index > 0  ? "mt-2":""}
                                    >
                                
                            </Form.Control>
                        </div>
                    );
                }
                    
                //}
                //else{
                //    return null;
                //}
                
            
            case 'TEXT':
                return (
                    <div className="mb-1 mt-1">
                        
                        <Form.Control
                                
                                    type="text"
                                    //keyboardType="numeric"
                                    id={"q_" + question.questionCode.toLowerCase() /* + "_" + question.id*/}
                                    //title={v.title}
                                    /*label={ 
                                        q.description != null 
                                        ?   parse(q.description) 
                                        :   null
                                    }*/
                                    name={q.questionCode}
                                    value={trimString(q.value, q.maxLength, q.maxValue)}
                                    onChange={(e) => updateQuestion(e, dispatch, question, subSection)}
                                    //checked={false}
                                    isInvalid={q.isInvalid}
                                    isValid={q.isValid}
                                    //hidden={question.questionCode.toLowerCase()=="pso29" ? true : false}
                                    //min="1"
                                    disabled={q.checked==true || pageType=="VIEW" ? true : q.disabled}
                                    title={q.maxValue!=null ? "If none, enter '0'. Maximum answer value for this question is " + q.maxValue : null} 
                                    //max={q.maxLength!=null ? q.maxLength : null}
                                    //ref={fieldData.InputRef}
                                    //className={index > 0  ? "mt-2":""}
                                >
                            
                        </Form.Control>
                        
                        
                        
                        
                    </div>
                );

            case 'DATE':
                return (
                    <div className="mb-1 mt-1">
                        
                        <Form.Control
                            type="date"
                            //keyboardType="numeric"
                            id={"q_" + question.questionCode.toLowerCase() /* + "_" + question.id*/}
                            //title={v.title}
                            /*label={ 
                                q.description != null 
                                ?   parse(q.description) 
                                :   null
                            }*/
                            name={q.questionCode}
                            value={trimString(q.value, q.maxLength, q.maxValue)}
                            onChange={(e) => updateQuestion(e, dispatch, question, subSection)}
                            //checked={false}
                            isInvalid={q.isInvalid}
                            isValid={q.isValid}
                            //hidden={question.questionCode.toLowerCase()=="pso29" ? true : false}
                            //min="1"
                            disabled={q.checked==true || pageType=="VIEW"? true : q.disabled}
                            title={q.maxValue!=null ? "If none, enter '0'. Maximum answer value for this question is " + q.maxValue : null} 
                            //max={q.maxLength!=null ? q.maxLength : null}
                            //ref={fieldData.InputRef}
                            //className={index > 0  ? "mt-2":""}
                            /*className={getVarValue(fieldData.disabled) && (fieldData.value == null || fieldData.value == "")
                                ? "hide-text"
                                : ""
                            }*/
                        >
                            
                        </Form.Control>
                        
                        
                        
                    </div>
                );
                
            
            case 'NUMBER':
                //console.log(q.description);
                //console.log(parse(q.description) )

                    return (
                        <div className="mb-1 mt-1">
                            
                            {   question.questionCode=="pso29" 
                                ?   null
                                :   <Form.Control
                                    
                                        type="number"
                                        //keyboardType="numeric"
                                        id={"q_" + question.questionCode.toLowerCase() /* + "_" + question.id*/}
                                        //title={v.title}
                                        /*label={ 
                                            q.description != null 
                                            ?   parse(q.description) 
                                            :   null
                                        }*/
                                        name={q.questionCode}
                                        value={q.value == -1 ? "" : trimNumber(q.value, q.maxLength, q.maxValue)}
                                        onChange={(e) => updateQuestion(e, dispatch, question, subSection)}
                                        //checked={false}
                                        isInvalid={q.isInvalid}
                                        isValid={q.isValid}
                                        //hidden={question.questionCode.toLowerCase()=="pso29" ? true : false}
                                        //min="1"
                                        disabled={q.checked==true || pageType=="VIEW"? true : q.disabled}
                                        title={q.maxValue!=null ? "If none, enter '0'. Maximum answer value for this question is " + q.maxValue : null} 
                                        //max={q.maxLength!=null ? q.maxLength : null}
                                        //ref={fieldData.InputRef}
                                        //className={index > 0  ? "mt-2":""}
                                    >
                                
                            </Form.Control>
                            }   
                            {
                                    q.questionCode=="pso30" || q.questionCode=="pso31" ?
                                    
                                        pageType=="VIEW" && q.checked==true
                                        ?
                                            <p className="mt-2">
                                                PSO chooses to not provide an answer
                                            </p> 
                                        :
                                            pageType!="VIEW" ?
                                                <Form.Check
                                                    type="checkbox"
                                                    label={ "PSO chooses to not provide an answer"}
                                                    name={q.questionCode}
                                                    id={"qchk_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                                    value={-1}
                                                    onChange={(e) => updateQuestion(e, dispatch, question, subSection)}
                                                    className="mt-2 mb-2"
                                                    checked={q.checked}
                                                    isInvalid={q.isInvalid}
                                                    isValid={q.isValid}
                                                    hidden={question.questionCode.toLowerCase()=="pso29" ? true : false}
                                                    disabled={pageType=="VIEW" ? true : false}
                                                    //disabled={disabled(v.disabled, fieldData.disabled)}//v.disabled ? true : false}
                                                    //ref={fieldData.InputRef}
                                                    //className={index > 0  ? "mt-2":""}
                                                />
                                            :   null
                                    : null
                            }
                            
                        </div>
                    );  

                
                case 'INDT_NUMBER':
                    //console.log(q.description);
                    //console.log(parse(q.description) )
                    return (
                        <div className="mb-1 mt-1">
                            
                            {   question.questionCode=="pso29" 
                                ?   null
                                :   <Form.Control
                                    
                                        type="number"
                                        //keyboardType="numeric"
                                        id={"q_" + question.questionCode.toLowerCase() /* + "_" + question.id*/}
                                        //title={v.title}
                                        /*label={ 
                                            q.description != null 
                                            ?   parse(q.description) 
                                            :   null
                                        }*/
                                        name={q.questionCode}
                                        value={q.value == -1 ? "" : trimNumber(q.value, q.maxLength, q.maxValue)}
                                        onChange={(e) => updateQuestion(e, dispatch, question, subSection)}
                                        //checked={false}
                                        isInvalid={q.isInvalid}
                                        isValid={q.isValid}
                                        //hidden={question.questionCode.toLowerCase()=="pso29" ? true : false}
                                        //min="1"
                                        disabled={q.checked==true || pageType=="VIEW"? true : q.disabled}
                                        title={q.maxValue!=null ? "If none, enter '0'. Maximum answer value for this question is " + q.maxValue : null} 
                                        //max={q.maxLength!=null ? q.maxLength : null}
                                        //ref={fieldData.InputRef}
                                        //className={index > 0  ? "mt-2":""}
                                    >
                                
                            </Form.Control>
                            }   
                                
                            
                            {
                                    q.questionCode=="pso30" || q.questionCode=="pso31" ?
                                    
                                    <Form.Check
                                        
                                        type="checkbox"
                                        label={ "PSO chooses to not provide an answer"}
                                        name={q.questionCode}
                                        id={"qchk_" + question.questionCode.toLowerCase()/* + "_" + question.id*/}
                                        value={-1}
                                        onChange={(e) => updateQuestion(e, dispatch, question, subSection)}
                                        className="mt-2 mb-2"
                                        checked={q.checked}
                                        isInvalid={q.isInvalid}
                                        isValid={q.isValid}
                                        hidden={question.questionCode.toLowerCase()=="pso29" ? true : false}
                                        disabled={pageType=="VIEW" ? true : false}
                                        //disabled={disabled(v.disabled, fieldData.disabled)}//v.disabled ? true : false}
                                        //ref={fieldData.InputRef}
                                        //className={index > 0  ? "mt-2":""}
                                    />
                                : null
                            }
                            
                        </div>
                    );
        }
        
    }



const labelField = () => {
    var q = section.questions[subSection][question.questionCode.toLowerCase()];
    if(question.questionCode != null && (question.questionCode != "pso26" || (pageType=="VIEW" && reportYear.value < 2020))){
        if(section.questions[subSection][question.questionCode.toLowerCase()].answers !=null && section.questions[subSection][question.questionCode.toLowerCase()].answers.length>0){
            return (
                section.questions[subSection][question.questionCode.toLowerCase() /* + "_" + question.id*/].questionDisplayNo != null
                ?
                    section.questions[subSection][question.questionCode.toLowerCase() /* + "_" + question.id*/].description != null
                        
                    ?   <Stack className="align-items-start" direction="horizontal" gap={0}>
                            <div className="ps-3 col-1 form-num">{section.questions[subSection][question.questionCode.toLowerCase() /* + "_" + question.id*/].questionDisplayNo + ". "}</div>
                            <div className="">{displayLabel(parse(section.questions[subSection][question.questionCode.toLowerCase() /* + "_" + question.id*/].description), false, Col,true)}</div>
                        </Stack>
                    :   null

                :   //null 
                    section.questions[subSection][question.questionCode.toLowerCase()].description != null
                    ?   <Stack className="align-items-start" direction="horizontal" gap={0}>
                            <div className="ps-3 col-1">{null}</div>
                            <div className="">{displayLabel(parse(section.questions[subSection][question.questionCode.toLowerCase() ].description), false, Col,false)}</div>
                        </Stack>
                    :   null
            )
        }
        else{
        
            return (q.questionDisplayNo != null
                ?
                    q.description != null
                        // <Form.Label htmlFor={"q_" + question.questionCode.toLowerCase()}>
                        //{questionLabel(q)}
                        //</Form.Label>
                    ?   <Stack className="align-items-start" direction="horizontal" gap={0}>
                            <div className="ps-3 col-1 form-num">{q.questionDisplayNo + ". "}</div>
                            <div className="">{displayLabel(parse(q.description), false, Col,true,"q_" + question.questionCode.toLowerCase())}</div>
                        </Stack>
                    :   null

                :   //null 
                    q.description != null
                    ?   <Stack className="align-items-start" direction="horizontal" gap={0}>
                            <div className="ps-3 col-1">{null}</div>
                            <div className="">{displayLabel(parse(q.description), false, Col,false,"q_" + question.questionCode.toLowerCase())}</div>
                        </Stack>
                    :   null
            )
        }
        
    }
    else{
        return null;
    }
    
}

const subTextField = () => {
    if(question.questionCode != null){
        if(section.questions[subSection][question.questionCode.toLowerCase()].subText != null){
            
                return  <p> {parse(section.questions[subSection][question.questionCode.toLowerCase()].subText)} </p>;
            
            
        }
        else{
            return null;
        }
    }
    else{
        return null;
    }
    
    
}



function questionDisplayConditions () {
    //console.log("questionDisplayConditions");
    
    /*if(question.questionCode === "pso21" &&  (section.questions[subSection]["pso28"].answers).length > 0 && (section.questions[subSection]["pso28"].answers).find(a => a.answerCode === "C019").checked == true ){
        return true;
    }
    else*/ if(question.questionCode === "pso26" ){
        var an = (section.questions[subSection][getQuestionIdByCode("pso14",section.questions[subSection])].answers);
        var find = an.find(a => a.answerCode === "C055");
        if(an.length > 0 && find!=null && find.checked == true || an.every(a => a.checked == false)){
            return true;
        }
    }
    else if (question.questionCode === "pso26" &&  (section.questions[subSection][getQuestionIdByCode("pso21",section.questions[subSection])].answers).length > 0 && (section.questions[subSection][getQuestionIdByCode("pso21",section.questions[subSection])].answers).find(a => a.answerCode === "C055").checked == true ){
        return true;
    }
    else if(question.questionCode=="prov07"){
        var ans = section.questions.allProviderTypes[getQuestionIdByCode("prov03",section.questions["allProviderTypes"])].answers;
        var cb = getCheckedBoxes(ans);

        //console.log(cb);
       
        var vals = ['C001','C002','C183','C214','C215','C216']

        if(cb!=null){
            for(var y = 0 ; y<vals.length ; y++){
                if(cb.includes(vals[y])){
                    return false;
                }
            }
        }
        return true;
    }
    else{
        return false;
    }
}

function isQuestionVisible(){
   if(pageType=="VIEW"){
        //if(question.questionCode=="pso27" && question.value=="" || question.value==null){
        //    return false;
        //}
        //console.log(getCheckedValueBoxes(question.answers));

        if((question.typeCode=="CHECKBOX_NUMBER" || question.typeCode=="CHECKBOX" || question.typeCode=="RADIO")){
            if(Object.keys(getCheckedValueBoxes(question.answers)).length === 0){
                
                return false;
            }
        }
        if((question.typeCode=="TEXT" || question.typeCode == "DATE" || question.typeCode == "NUMBER" || question.typeCode=="NUMBER_NP" || question.typeCode=="INDT_NUMBER")  ){
            if(question.hasOwnProperty("answers")==true || question.answers.length==0){
                if(question.value==null || question.value==""){
                    //console.log(question);
                    if(reportYear.value>2019 && question.questionCode=="pso29"){
                        var pso30 = (section.questions[subSection][getQuestionIdByCode("pso30",section.questions[subSection])]);
                        var pso31 = (section.questions[subSection][getQuestionIdByCode("pso31",section.questions[subSection])]);
                        if(pso30.value!=null || pso31.value!=null || pso30.checked==true || pso31.checked==true){
                            return true;
                        }
                        else{
                            return false;
                        }
                        //console.log(pso30);
                        
                    }
                    return false;
                }
            }
            else if(question.hasOwnProperty("answers")==true || question.answers.length>0){
                var a = isAnyAnswered(question.answers);
                return a;
            }
            
        }
    }
    return true;
}

function answerDisplayConditions(answerCode,geoType){

    if(question.questionCode === "pso26" && (question.answers).length > 0){

        var pso14 = section.questions[subSection][getQuestionIdByCode("pso14",section.questions[subSection])];

        //console.log(pso14);

        var c196 = (section.questions[subSection][getQuestionIdByCode("pso14",section.questions[subSection])].answers).find(a => a.answerCode === "C196");
        var c195 = (section.questions[subSection][getQuestionIdByCode("pso14",section.questions[subSection])].answers).find(a => a.answerCode === "C195");
        
        var c055 = (section.questions[subSection][getQuestionIdByCode("pso14",section.questions[subSection])].answers).find(a => a.answerCode === "C055");
        var c057 = (section.questions[subSection][getQuestionIdByCode("pso14",section.questions[subSection])].answers).find(a => a.answerCode === "C057");

        //console.log(question);

        //console.log(c196);
        //console.log(c195);
        //console.log(c055);
        //console.log(c057);
        
        if(reportYear.value>=2020){
            if(pso14!=null && c196!=null && (section.questions[subSection][getQuestionIdByCode("pso14",section.questions[subSection])].answers).find(a => a.answerCode === "C196").checked == true){
                return false;
            }
            else if(pso14!=null && c195!=null && (section.questions[subSection][getQuestionIdByCode("pso14",section.questions[subSection])].answers).find(a => a.answerCode === "C195").checked == true){
                return false;
            }
            else{
                return true;
            }
        }
        else{
            //console.log(c057.checked);
            if(pso14!=null && c057!=null && c057.checked == true){
                return false;
            }
            
            else{
                return true;
            }
        }
        

        /*if(answerCode==="C196" && e.target.checked==true){
            
        }
        if(answerCode==="C195" && e.target.checked==true){
            return false;
        }
        else{
            return true;
        }*/
        //clearQuestionAnswers(dispatch,question,subSection);
        
    }
    else{
        return false;
    }
}

var q = section.questions[subSection][question.questionCode.toLowerCase()];

return (

    question.questionCode != null 
        ?
            //questionDisplayConditions()
            section.questions[subSection][question.questionCode.toLowerCase()].visible==false || isQuestionVisible() == false
            ?   null
            : 
                
                    q.typeCode=="RADIO" || q.typeCode=="CHECKBOX" || q.typeCode=="CHECKBOX_NUMBER" 
                    ?   <fieldset>
                            { notes!=null && question.questionCode == 'pso13'? 
                                <PageInfo classes="mt-1 mb-4" type="info" message={
                                    notes.PSOCharsPt2
                                }></PageInfo>
                                : null
                            }
                            {labelField()}
                            <Row className="flex-nowrap mb-3">
                                <Col xs={1}>
                                    <p></p>
                                </Col>
                                <Col xs={11}>
                                    
                                    {subTextField()}
                                    {
                                        (section.questions[subSection][question.questionCode.toLowerCase()/* + "_" + question.id*/].answers)!=null && (section.questions[subSection][question.questionCode.toLowerCase()/* + "_" + question.id*/].answers).length > 0 
                                        ?    
                                            <>
                                                <Form.Control.Feedback tabIndex={-1} ref={(e)=>{setInputRefs(e,question.questionCode.toLowerCase())}} className={section.questions[subSection][question.questionCode.toLowerCase()].isInvalid ? "is-invalid mt-3 mb-3" : ""} type="invalid">
                                                    {displayErrors(section.questions[subSection][question.questionCode.toLowerCase()])}
                                                </Form.Control.Feedback>
                                                {answerLoop()}
                                                
                                            </>
                                        :    <div >
                                                <Form.Control.Feedback tabIndex={-1} ref={(e)=>{setInputRefs(e,question.questionCode.toLowerCase())}} className={section.questions[subSection][question.questionCode.toLowerCase()].isInvalid ? "is-invalid mt-3 mb-3" : ""}  type="invalid">
                                                    {displayErrors(section.questions[subSection][question.questionCode.toLowerCase()])}
                                                </Form.Control.Feedback>
                                                {questionField()}
                                                
                                            </div>
                                            
                                        
                                    }
                                    
                                </Col>
                            </Row>
                        </fieldset>
                    :   <>
                    
                            { notes!=null && question.questionCode == 'pso13'? 
                                <PageInfo classes="mt-1 mb-4" type="info" message={
                                    notes.PSOCharsPt2
                                }></PageInfo>
                                : null
                            }

                            {labelField()}
                            <Row className="flex-nowrap mb-3">
                                <Col xs={1}>
                                    <p></p>
                                </Col>
                                <Col xs={11}>
                                    
                                    {subTextField()}
                                    {
                                        (section.questions[subSection][question.questionCode.toLowerCase()/* + "_" + question.id*/].answers)!=null && (section.questions[subSection][question.questionCode.toLowerCase()/* + "_" + question.id*/].answers).length > 0 
                                        ?    
                                            <>
                                                <Form.Control.Feedback tabIndex={-1} ref={(e)=>{setInputRefs(e,question.questionCode.toLowerCase())}} className={section.questions[subSection][question.questionCode.toLowerCase()].isInvalid ? "is-invalid mt-3 mb-3" : ""} type="invalid">
                                                    {displayErrors(section.questions[subSection][question.questionCode.toLowerCase()])}
                                                </Form.Control.Feedback>
                                                {answerLoop()}
                                                
                                            </>
                                        :    <div >
                                                <Form.Control.Feedback tabIndex={-1} ref={(e)=>{setInputRefs(e,question.questionCode.toLowerCase())}} className={section.questions[subSection][question.questionCode.toLowerCase()].isInvalid ? "is-invalid mt-3 mb-3" : ""} type="invalid">
                                                    {displayErrors(section.questions[subSection][question.questionCode.toLowerCase()])}
                                                </Form.Control.Feedback>
                                                {questionField()}
                                                
                                            </div>
                                            
                                        
                                    }
                                    
                                </Col>
                            </Row>
                        </>
                   
                  
                    
                
        :   null

    
)
}


export default PSOFormFields;